import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-pantera-runner',
  templateUrl: './pantera-runner.component.html',
  styleUrls: ['./pantera-runner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanteraRunnerComponent {}
